import { useState } from "react";
import { IBenefitFilters } from "../../interfaces/benefit";
import {
  downloadBenefitTemplate,
  exportBenefits,
} from "../../services/benefitService";
import { DownloadIcon, RefreshIcon, SendIcon, UploadIcon } from "../ui/Icons";

interface IToolbarProps {
  filters: IBenefitFilters;
  isLoading: boolean;
  pendingCount: number;
  hasRecords: boolean;
  onUploadClick: () => void;
  onSendClick: () => void;
  onRefresh: () => void;
  onError: (message: string) => void;
}

export default function Toolbar({
  filters,
  isLoading,
  pendingCount,
  hasRecords,
  onUploadClick,
  onSendClick,
  onRefresh,
  onError,
}: IToolbarProps) {
  const hasPending: boolean = pendingCount > 0;
  const [isExporting, setIsExporting] = useState<boolean>(false);
  const [isDownloadingTemplate, setIsDownloadingTemplate] = useState<boolean>(false);

  // el excel exportado respeta los filtros aplicados en la tabla
  const handleExport = async (): Promise<void> => {
    setIsExporting(true);

    try {
      await exportBenefits({ filters });
    } catch (error) {
      console.error("ERROR AL EXPORTAR", error);
      onError("No pudimos generar el excel de resultados.");
    } finally {
      setIsExporting(false);
    }
  };

  const handleTemplate = async (): Promise<void> => {
    setIsDownloadingTemplate(true);

    try {
      await downloadBenefitTemplate();
    } catch (error) {
      console.error("ERROR AL DESCARGAR PLANTILLA", error);
      onError("No pudimos descargar la plantilla de carga.");
    } finally {
      setIsDownloadingTemplate(false);
    }
  };

  return (
    <div className="toolbar">
      <button type="button" className="btn btn--primary" onClick={onUploadClick}>
        <UploadIcon size={15} />
        Cargar nómina
      </button>

      <button
        type="button"
        className="btn btn--send"
        onClick={onSendClick}
        disabled={!hasPending}
        title={
          hasPending
            ? undefined
            : "No hay registros pendientes de envío"
        }
      >
        <SendIcon size={15} />
        Enviar mensajes
      </button>

      <button
        type="button"
        className="btn btn--soft"
        onClick={handleExport}
        disabled={isExporting || isLoading || !hasRecords}
        title={hasRecords ? undefined : "No hay registros para descargar"}
      >
        {isExporting ? <span className="btn__spin" /> : <DownloadIcon size={15} />}
        Descargar resultados
      </button>

      <button
        type="button"
        className="btn"
        onClick={handleTemplate}
        disabled={isDownloadingTemplate}
      >
        {isDownloadingTemplate ? (
          <span className="btn__spin" />
        ) : (
          <DownloadIcon size={15} />
        )}
        Descargar plantilla
      </button>

      <div className="toolbar__spacer" />

      <button
        type="button"
        className="btn btn--sm btn--ghost"
        onClick={onRefresh}
        disabled={isLoading}
        aria-label="Refrescar"
      >
        {isLoading ? <span className="btn__spin" /> : <RefreshIcon size={15} />}
        Refrescar
      </button>
    </div>
  );
}
